<template>
  <div class="relative">
    <img ref="imgRef" :src="imgSrc" alt="" class="object-cover" />
    <div v-if="imgOverlaySrc" class="absolute inset-0 overflow-hidden">
      <img class="object-cover" :src="imgOverlaySrc" alt="" />
    </div>
    <div v-if="meterRead" class="absolute inset-0">
      <div
        class="font-calculator text-gray-900 absolute flex items-center justify-end"
        :style="{ ...meterReadStyles, fontSize: meterReadFontSize }"
      >
        {{ meterRead }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { DeviceTypeToImgUrl, getMeterReadOnLCD } from '@/utils/device.utils';
import { Device, DeviceTypeHelper, Gateway, RR4Read, RR3Read, DeviceFamily } from '@ncss/models/dist/v3';
import { useElementSize } from '@vueuse/core';
import { computed, ref } from 'vue';

const props = defineProps<{ device?: Device }>();
const imgRef = ref();
const imgSrc = computed(() => {
  const device = props.device;
  if (device) {
    if (!device.id) {
      return device instanceof Gateway
        ? 'equipment/device-types/NoGateway.png'
        : 'equipment/device-types/NoUnitDevice.png';
    }
    return DeviceTypeToImgUrl(DeviceTypeHelper.GetDeviceTypeBySerialNumber(device.id));
  }
  return 'equipment/device-types/NoUnitDevice.png';
});
const imgOverlaySrc = computed(() => {
  const device = props.device;
  if (device?.id && DeviceTypeHelper.GetFamilyBySerialNumber(device.id) === DeviceFamily.REMOTE_READER) {
    return 'equipment/device-types/remote-reader-lcd-overlay.png';
  }
});
const meterRead = computed(() => {
  const device = props.device;
  if (device?.data instanceof RR4Read || device?.data instanceof RR3Read) {
    return getMeterReadOnLCD(device.data);
  }
  return null;
});
const meterReadStyles = computed(() => {
  const device = props.device;
  if (device?.data instanceof RR4Read || device?.data instanceof RR3Read) {
    return { top: '43%', left: '37%', right: '37%', bottom: '44.8%' };
  }
  return null;
});
const { width } = useElementSize(imgRef);
const meterReadFontSize = computed(() => width.value / 270 + 'em');
</script>
